import React from "react";

/* create Get Started button */
export function GetStarted() {
  return (
    <button type="button" className="w-full py-4 -my-1 bg-indigo-700">
      Get Started
    </button>
  );
}
